import React from "react";
import ErrorMainSection from "../components/error_page/error_content_main_section";
function ErrorPage() {
  return <ErrorMainSection />;
}
export default ErrorPage;